export default __webpack_public_path__ + "static/media/cm-royal.e02804cb.png";